import DomComponent from 'App/lib/domComponent';
import { each } from 'App/lib/util';

export default class CurbsideToGo extends DomComponent {
    static selector = '.ww-rich-text table';

    constructor(el) {
        super(el);

        setTimeout(() => {
            this.loaded();
        });
        this.tr = this.el.querySelectorAll('tr');
        this.td = this.el.querySelectorAll('td');
        this.tdPhone = this.el.querySelectorAll('tr td:nth-child(2)');
        this.tdThird = this.el.querySelectorAll('tr td:nth-child(3)');
        this.tdFourth = this.el.querySelectorAll('tr td:nth-child(4)');
        this.tdFifth = this.el.querySelectorAll('tr td:nth-child(5)');
        this.curbsideToGo();
        this.dogFriendly();
    }

    removeAttributes() {
        this.el.removeAttribute('width');
        this.el.removeAttribute('height');
        this.el.removeAttribute('style');
        this.el.removeAttribute('border');

        each(this.tr, (tr, index) => {
            tr.removeAttribute('style');
            if (index === 0 && this.tr.length > 1) {
                tr.style.display = 'none';
            }
        });

        each(this.td, (td) => {
            td.removeAttribute('style');
            if(td.innerText.trim().length == 0 || td.innerText.trim() == "&nbsp;" || td.innerText.trim() == '-') {
                td.style.display = 'none';
            }
        });
    }

    curbsideToGo() {
        if (location.href.indexOf('curbside-to-go') === -1) {
            return;
        }

        // Desktop
        if (screen.width > 768) {
            this.el.removeAttribute('border');
            this.el.removeAttribute('style');
            this.el.classList.add('curbside-to-go--desktop');
            this.el.parentNode.style.maxWidth = '1140px';
            return;
        }

        this.el.classList.add('curbside-to-go');
        this.removeAttributes();

        const stripTagsRegex = /(<p[^>]+?>|<p>|<\/p>|<div[^>]+?>|<div>|<\/div>)/img;

        each(this.tdPhone, (td) => {
            td.innerHTML = `<strong>PHONE NUMBER: </strong> ${td.innerHTML.replace(stripTagsRegex, '')}`;
        });

        // Dinning Curbside
        if (location.href.indexOf('dining') > -1) {
            each(this.tdThird, (td) => {
                td.innerHTML = `<strong>NEAREST CURBSIDE PICK-UP LOCATION: </strong> ${td.innerHTML.replace(stripTagsRegex, '')}`;
            });

            each(this.tdFourth, (td) => {
                td.innerHTML = `<strong>OPEN FOR IN-STORE DINING: </strong> ${td.innerHTML.replace(stripTagsRegex, '')}`;
            });

            each(this.tdFifth, (td) => {
                td.innerHTML = `<strong>OFFERS<sup>*</sup>: </strong> ${td.innerHTML}`;
            });
        }
        // Shopping Curbside
        else {
            each(this.tdThird, (td) => {
                td.innerHTML = `<strong>CURBSIDE PICK-UP LOCATION: </strong> ${td.innerHTML.replace(stripTagsRegex, '')}`;
            });

            each(this.tdFourth, (td) => {
                td.innerHTML = `<strong>OPEN FOR IN-STORE SHOPPING: </strong> ${td.innerHTML.replace(stripTagsRegex, '')}`;
            });
        }
    }

    dogFriendly() {
        if (location.href.indexOf('guest-services/dog-friendly') === -1) {
            return;
        }

        // If the table only has 1 row, then don't change it
        if (this.tr.length === 1) {
            return;
        }

        // Desktop
        if (screen.width > 768) {
            this.el.removeAttribute('border');
            this.el.removeAttribute('style');
            this.el.classList.add('dog-friendly--desktop');
            return;
        }

        this.el.classList.add('dog-friendly');
        this.removeAttributes();

        const stripTagsRegex = /(<p[^>]+?>|<p>|<\/p>|<div[^>]+?>|<div>|<\/div>)/img;

        each(this.tdPhone, (td) => {
            td.innerHTML = `<strong>PHONE NUMBER: </strong> ${td.innerHTML.replace(stripTagsRegex, '')}`;
        });
    }
}